import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { getRoutes } from "./routes";

const Navigation = () => {
  return <RouterProvider router={createBrowserRouter(getRoutes())} />;
};

export default Navigation;
